export const fileManagerData = [
  {
    id: "1",
    name: "Digimed",
    lastModified: "Today 08:30 AM by Angel",
    size: "200 MB",
    name2: "Nolan Christopher",
    avatar: "assets/img/avatar/avatar-6.jpg",
    avatar2: "assets/img/icons/folder.svg"
  },
  {
    id: "2",
    name: "Estimation",
    lastModified: "Today 09:20 AM",
    size: "140 MB",
    name2: "Nolan Harris",
    avatar: "assets/img/avatar/avatar-5.jpg",
    avatar2: "assets/img/icons/xls.svg"
  },
  {
    id: "3",
    name: "Intro.pdf",
    lastModified: "27 July 2023",
    size: "70 MB",
    name2: "Me",
    avatar: "assets/img/avatar/avatar-10.jpg",
    avatar2: "assets/img/icons/pdf-02.svg"
  },
  {
    id: "4",
    name: "Demoworking.mp4",
    lastModified: "24 July 2023 at 08:25 AM",
    size: "180 MB",
    name2: "Daniel",
    avatar: "assets/img/avatar/avatar-2.jpg",
    avatar2: "assets/img/icons/video.svg"
  },
  {
    id: "5",
    name: "voice.mp3",
    lastModified: "27 July 2023",
    size: "80 MB",
    name2: "Henriques",
    avatar: "assets/img/avatar/avatar-7.jpg",
    avatar2: "assets/img/icons/audio.svg"
  },
];
